
import '../App.css';
import { SiLinkedin } from "react-icons/si";
import { SiGithub } from "react-icons/si";
import { FaStackOverflow } from "react-icons/fa";
import { FaMedium } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { FaEmail } from "react-icons/fa";
import { AiFillMail } from "react-icons/ai";
import { FaGlobeEurope } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import {FaLocationArrow} from 'react-icons/fa';
function BannerInfo() {
  return (
    <div className='Banner-Info'>

      <div className='Left-Banner-Info'>

        <div className='Left-Banner-Up'>
          <div className='Left-Banner-Items'><SiLinkedin /><a href={'https://www.linkedin.com/in/neeraj-malwal-40070a1a7/'} target={'_blank'}>Linkedin</a></div>
          <div className='Left-Banner-Items'><SiGithub /><a href={'https://github.com/neerajmasai'} target={'_blank'}>Github</a></div>
          <div className='Left-Banner-Items'><FaStackOverflow /><a href={'https://stackoverflow.com/users/12056503/neeraj-malwal'} target={'_blank'}>Stack Overflow</a></div>
          <div className='Left-Banner-Items'><FaMedium /><a href={'https://medium.com/@neeraj_fw10_110/how-i-made-my-first-website-clone-and-how-you-can-too-4f20bad0a4'} target={'_blank'}>Medium</a></div>
        </div>

        <div className='Left-Banner-Down'>
          <div className='Left-Banner-Items'><FaPhone /><a href='#'>Phone: +91 9588686878</a></div>
          <div className='Left-Banner-Items'><AiFillMail /><a href='#'>Email: neerajmalwal10@gmail.com</a></div>
          <div className='Left-Banner-Items'><FaGlobeEurope /><a href='#'>Speaks: English, Hindi and Marathi</a></div>
          <div className='Left-Banner-Items'><FaLocationArrow /><a href='#'>Located in: Pune, India</a></div>
        </div>

      </div>

      <div className='Right-Banner-Info'>
        <img src="https://namanhkapur.super.site/_next/image?url=https%3A%2F%2Fsuper-static-assets.s3.amazonaws.com%2Fb3cec3a3-f730-4617-a85f-4467419043f4%2Fimages%2F7f15458a-ba9f-46fd-8fb2-d52055afeadf.png&w=640&q=80" alt="" srcset="" />
      </div>
    </div>
  );
}

export default BannerInfo;
